var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CODealerRequestList"}},[_c('div',{attrs:{"id":"container-center"}},[_c('requestListContent')],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('b-button',{staticClass:"backbutton is-primary",on:{"click":_vm.back}},[_vm._v("戻る")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a2bab4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mock/guest/careorchestrator/CODealerRequestList.vue
// module id = null
// module chunks = 